"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var assetManager_1 = require("../service/assetManager");
var constants_1 = require("../constants/constants");
var useRecaptcha = function () {
    react_1.useEffect(function () {
        assetManager_1.assetManager.removeStyle(constants_1.default.RECAPTCHA_CSS_URL, true);
        assetManager_1.assetManager.loadScript(constants_1.default.RECAPTCHA_SITE_URL);
        return function () {
            assetManager_1.assetManager.removeScript(constants_1.default.RECAPTCHA_SITE_URL, true);
            assetManager_1.assetManager.loadStyle(constants_1.default.RECAPTCHA_CSS_URL);
        };
    }, []);
};
exports.default = useRecaptcha;
